export default __webpack_public_path__ + "static/daniil-tkalenko-c53b92558e2ff1a5e2c9c84548c43790.png";